import {
  IntegrationConnection,
  IntegrationEditRequest,
} from '@aibees/elephant/types/integration';
import { HttpMethod } from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';
import { useBrowseIntegrationApi } from './use-browse-integration-api';
import { useBrowseIntegrationCountApi } from './use-browse-integration-count-api';

export function useUpdateIntegrationMutationApi(id?: string) {
  const workspace = useWorkspace();
  return useBaseMutation<IntegrationEditRequest, IntegrationConnection>(
    {
      url: `${INTEGRATION_API_PREFIX.replace(
        ':wid',
        String(workspace?.id)
      )}/${id}`,
      method: HttpMethod.patch,
    },
    {
      onSuccess() {
        baseQueryClient.invalidateQueries([useBrowseIntegrationCountApi.name]);
        baseQueryClient.invalidateQueries([useBrowseIntegrationApi.name]);
      },
    }
  );
}
